import React from 'react';
import { applyTypography, BaseButton, useT } from '@repo/common';

// 약관 개정 안내 메일 전체 발송 직전 확인
const SendPolicyNoticeModal = ({ isOpen, onClose, onConfirm, summary }) => {
  const t = useT();

  if (!isOpen || !summary) return null;

  const rows = [
    [t('To', '받는 사람'), summary.audience],
    [t('From', '보내는 사람'), summary.from],
    [t('Subject', '제목'), summary.subject],
    [t('Effective date', '시행일'), summary.effectiveDate],
    [t('Campaign key', '발송 키'), summary.campaignKey],
    [
      t('Not yet received', '아직 못 받은 회원'),
      t(`${summary.pending.toLocaleString()} people`, `${summary.pending.toLocaleString()}명`),
    ],
    [
      t('Sending now', '이번에 보낼 인원'),
      t(`Up to ${summary.willSend.toLocaleString()}`, `최대 ${summary.willSend.toLocaleString()}명`),
    ],
  ];

  return (
    <>
      <div
        className='fixed inset-0 bg-surface-black40 z-[10000000000]'
        onClick={onClose}
      />
      <div className='fixed inset-0 z-[10000000001] flex items-center justify-center px-[16px] py-[24px]'>
        <div
          role='dialog'
          aria-modal='true'
          className='bg-grayscale-gray00 w-full max-w-[520px] max-h-full overflow-y-auto rounded-[20px] p-[24px] tabletH:p-[32px] flex flex-col gap-[16px] shadow-2'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='flex flex-col gap-[8px]'>
            <p className={`${applyTypography('title3')} text-text-primary`}>
              {t('Send the notice to members?', '회원들에게 안내 메일을 보낼까요?')}
            </p>
            <p
              className={`${applyTypography('b14')} text-text-secondary`}
              style={{ lineHeight: 1.6 }}
            >
              {t(
                'Sent emails cannot be recalled. Members who already received this campaign are skipped automatically.',
                '보낸 메일은 회수할 수 없어요. 같은 발송 키로 이미 받은 회원은 자동으로 제외됩니다.',
              )}
            </p>
          </div>

          <dl className='flex flex-col gap-[8px] rounded-[12px] bg-grayscale-gray01 p-[16px]'>
            {rows.map(([label, value]) => (
              <div key={label} className='flex gap-[12px]'>
                <dt className='typo-b13 text-text-placeholder w-[110px] shrink-0'>
                  {label}
                </dt>
                <dd className='typo-b13Strong text-text-primary break-all'>{value}</dd>
              </div>
            ))}
          </dl>

          <div className='flex gap-[8px] justify-end'>
            <BaseButton type='text_basic' size='m' hideIcon onClick={onClose}>
              {t('Cancel', '취소')}
            </BaseButton>
            <BaseButton type='primary' size='m' hideIcon onClick={onConfirm}>
              {t('Start sending', '발송 시작')}
            </BaseButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendPolicyNoticeModal;
